module.exports = "<holding-auth-header></holding-auth-header> <div class=initial-onboarding-container> <div ui-view=auth></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/auth/auth.html
// module id = 336
// module chunks = 0